angular.module('NumbersEditor')
    .service('gameService', ['PublishGameFactory','NewGameFactory','GameFactory','$q', 'moment', function (publishGameFactory, newGameFactory, gameFactory, $q, moment) {
        function gameService(publishGameFactory, newGameFactory, gameFactory, $q) {
            var self = this;
            self._publishGameFactory = publishGameFactory;
            self._newGameFactory = newGameFactory;
            self._gameFactory = gameFactory;
            self._$q = $q;
        };

        gameService.prototype.deleteGame = function(game) {
            var self = this;
            return self._gameFactory.deleteGame(game.Id);
        }

        gameService.prototype.saveGame = function (game) {
            var self = this;

            for (var i = 0; i < game.Events.length; i++) {
                
                const hours = parseInt(game.Events[i].EventTime.split(':')[0], 10);
                const minutes = parseInt(game.Events[i].EventTime.split(':')[1], 10);

                const eventTime = moment.tz(moment.tz.guess());
                const offset = eventTime.utcOffset() / 60;
                eventTime.set('hour', hours + offset);
                eventTime.set('minute', minutes);
                eventTime.set('second', 00);
                
                game.Events[i].EventTime = eventTime.valueOf();
            }

            return self._newGameFactory.insertGame(game);
        };

        gameService.prototype.getGame = function(gameId, sportCode, startDate) {
            var self = this;
            var deferred = self._$q.defer();
            self._gameFactory.getGame(gameId, sportCode, startDate)
                .success(function(game) {
                    for (var i = 0; i < game.Events.length; i++) {

                        const et = moment.tz(moment.tz.guess());
                        
                        var dateAndTime = game.Events[i].EventTime.split('T');
                        var eventTime = dateAndTime[1];
                        var hoursAndMinutes = eventTime.split(':');

                        et.set('hour', hoursAndMinutes[0]);
                        et.set('minute', hoursAndMinutes[1]);
                        
                        //console.log(et.format('HH:mm'));
                        //console.log(et.format().substring(0, et.format() - 6) + 'Z');

                        game.Events[i].EventTime = et.format('HH:mm'); // hoursAndMinutes[0] + ':' + hoursAndMinutes[1];
                        //game.Events[i].EventTimeDisplay = et.format(); //.substring(0, et.format()-6) + 'Z'; // hoursAndMinutes[0] + ':' + hoursAndMinutes[1];
                    }
                    deferred.resolve(game);
                })
                .error(function(error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        gameService.prototype.publishGame = function(gameId) {
            var self = this;
            return self._publishGameFactory.PublishGame(gameId);
        }

        gameService.prototype.setDatePicker = function ($scope) {
            var body = document.getElementsByTagName("body")[0];
            body.addEventListener("click", function () {
                $scope.opened = false;
            });

            window.setTimeout(function () {
                // Remove the close button on the date picker as it causes the dialog not to open
                var buttons = document.getElementsByClassName("btn-success");
                for (var i = 0; i < buttons.length; i++) {
                    if (buttons[i].parentElement.parentElement.classList.contains("dropdown-menu")) {
                        buttons[i].style.display = 'none';
                    }
                }
            }, 200);
        }

        return new gameService(publishGameFactory, newGameFactory, gameFactory, $q);
    }]);